<template>
    <div class="container_self">
        <el-row class="add_btn"><el-button type="primary" icon="el-icon-plus" size="mini" @click="addContact">新增运营人员联系方式</el-button></el-row>
        <h3>运营人员联系方式列表</h3>
        <el-row class="table_parent">
            <el-table :data="dataList" v-loading="loading">
                <el-table-column label="ID" align="center" prop="id" width="50"></el-table-column>
                <el-table-column label="用户ID" prop="userId" align="center"></el-table-column>
                <el-table-column label="名称" align="center" prop="name"></el-table-column>
                <el-table-column label="联系方式类型" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type==1">手机</span>
                        <span v-else-if="scope.row.type==2">邮箱</span>
                        <span v-else-if="scope.row.type==3">微信</span>
                        <span v-else-if="scope.row.type==4">QQ</span>
                        <span v-else-if="scope.row.type==5">地址</span>
                    </template>
                </el-table-column>
                <el-table-column label="联系方式" prop="contact" align="center"></el-table-column>
                <el-table-column label="说明" align="center" prop="description"></el-table-column>
                <el-table-column label="操作" align="center" width="180" fixed="right">
                    <template slot-scope="scope">
                       <el-button type="primary" size="mini" @click="updateContact(scope.row)">更新</el-button>
                       <el-button type="danger" size="mini" @click="deleteItem(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>



        <el-dialog :title="string+'运营人员联系方式'" :visible.sync="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
            <el-form :model="form" label-width="120px" :rules="rules" ref="ruleForm" size="mini" class="demo-ruleForm">
                <el-form-item label="选择用户" prop="userId">
                    <el-select v-model="form.userId" remote reserve-keyword filterable placeholder="请输入关键词" :remote-method="searchUser" clearable @change="changeUser" :disabled="cannotInput">
                        <el-option v-for="(item,index) in userList" :value="item.id" :label="item.name" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="类型" prop="type" placeholder="请选择联系方式类型">
                   <el-select v-model="form.type" @change="changeType" clearable>
                    <el-option :value="1" label="手机"></el-option>
                    <el-option :value="2" label="邮箱"></el-option>
                    <!-- <el-option :value="3" label="微信"></el-option>
                    <el-option :value="4" label="QQ"></el-option>
                    <el-option :value="5" label="地址"></el-option> -->
                   </el-select>
                </el-form-item>
                <el-form-item label="联系方式" prop="contact">
                    <el-input v-model="form.contact" placeholder="请输入联系方式" clearable></el-input>
                </el-form-item>
                <el-form-item label="是否接收通知" prop="notification">
                    <el-select  v-model="form.notification"  clearable>
                        <el-option :value="1" label="接收"></el-option>
                        <el-option :value="0" label="不接收"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="其他说明">
                    <el-input  v-model="form.description" autocomplete="off" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetForm('ruleForm')" size="mini">取 消</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')" size="mini">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
    import {axiosGet,axiosPost} from '@/assets/ajaxFn'
    export default {
        data(){
            return{
                dataList:[],
                searchForm:{
                    currentPage:1,
                    keyword:"",
                    notification:"",
                    pageSize:20
                },
                loading:false,
                dialogFormVisible:false,
                form:{
                    contact:"",
                    description:"",
                    notification:"",
                    type:"",
                    userId:""
                },
                rules:{
                    userId:[{required:true,message:"请先选择用户", trigger: 'blur'}],
                    type:[{required:true,message:"请先选择联系方式类型", trigger: 'blur'}],
                    contact:[{required:true,message:"请输入联系方式", trigger: 'blur'}],
                    notification:[{required:true,message:"请选择是否接收通知", trigger: 'blur'}]
                },
                userList:[],
                userInfo:{},
                cannotInput:false,
                edit:true,
                string:"新增"
            }
        },
        methods:{
            changeUser(val){
               this.userList.forEach(item=>{
                    if(item.id===val){
                        this.userInfo=item;
                    }
               })
            },
            changeType(val){
                if(val==2){
                    this.form.contact=this.userInfo.email;
                }
                if(val==5){
                    this.form.contact=this.userInfo.address1||this.userInfo.address||"";
                }
            },
            searchUser(keyword){
                if(keyword!=''){
                    this.getUserList({currentPage:1,pageSize:20,keyword:keyword});
                }
            },
            async getList(params){
              this.loading=true;
              await axiosGet('/api/staff/contact/list',params).then(res=>{
                    if(res.code==0){
                        this.dataList=res.data.records;
                    }
                })
                this.loading=false;
            },
           async submitForm(formName){
                const valid = await new Promise((resolve) => {
                    this.$refs[formName].validate((valid) => {
                        resolve(valid);
                    });
                });
                if(valid){
                  let url=this.edit?"/api/staff/contact/update":"/api/staff/contact/add";
                  await axiosPost(url,this.form,"JSON").then(res=>{
                        if(res.code==0){
                            if(this.edit){
                                this.$message({message:"联系方式更新成功",type:'success'});
                            }else{
                                this.$message({message:"联系方式新增成功",type:'success'});
                            }
                        }
                    })
                    this.getList(this.searchForm);
                    this.dialogFormVisible=false;
                }
            },
            resetForm(){
                this.dialogFormVisible=false;
                if(this.$refs.ruleForm){
                    this.$refs.ruleForm.resetFields(); // 重置表单验证
                }
              
            },
            deleteItem(row){
                this.$confirm('是否删除此联系方式?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        
                        axiosPost('/api/staff/contact/delete',{id:row.id},"JSON").then(res=>{
                            if(res.code==0){
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                this.getList(this.searchForm);
                            }
                        })
                }).catch(() => {});
            },
            updateContact(row){
               this.cannotInput=true;
               if(this.$refs.ruleForm){
                    this.$refs.ruleForm.resetFields(); // 重置表单验证
                }
               this.userList=this.getUserList({keyword:row.name});
               this.form=row;
               this.edit=true;
               this.string="修改";
               this.dialogFormVisible=true;
            },
           async getUserList(params){
                await axiosGet('/api/user/list',params).then(res=>{
                    if(res.code==0){
                        this.userList=res.data.records;
                    }
                })
            },
            addContact(){
                this.dialogFormVisible=true;
                this.userInfo={};
                this.userList=[];
                this.edit=false;
                this.string="新增";
                if(this.$refs.ruleForm){
                    this.$refs.ruleForm.resetFields(); // 重置表单验证
                }
                this.cannotInput=false;
                this.form={
                    contact:"",
                    description:"",
                    notification:"",
                    type:"",
                    userId:""
                };
            }
        },
        mounted(){
            this.getList(this.searchForm);
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/view/operationManager.vue